export default __webpack_public_path__ + "static/imgHome1-9d3e35c093c1a6d951f632a2426ea8bb.png";